import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Check = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox={props.BgColor ? "0 0 105 104" : "0 0 20 18"}
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={props.size}
            height={props.size}
            visibility={props.visibility}
            onClick={props.onClick}>
            {props.BgColor ? <rect x="0.5" width="104" height="104" rx="50" fill={props.BgColor} /> : null}
            <path fillRule="evenodd"
                clipRule="evenodd"
                d="M19.6783 0.265202C20.0841 0.639805 20.1094 1.27246 19.7348 1.67829L7.7348 14.6783C7.55021 14.8783 7.29208 14.9944 7.01999 14.9998C6.74789 15.0052 6.48533 14.8996 6.29289 14.7071L0.292893 8.70711C-0.0976311 8.31659 -0.0976311 7.68342 0.292893 7.2929C0.683417 6.90237 1.31658 6.90237 1.70711 7.2929L6.97115 12.5569L18.2652 0.321725C18.6398 -0.0840959 19.2725 -0.109402 19.6783 0.265202Z"
                fill={props.color ? props.color : "#0076A8"}/>
        </SvgStyled>
    );
};

export default Check;
